/** Mirrors `core/src/modules/schedules/schedules.types.ts`. */
export const scheduleTypes = [
  'battery-charge',
  'battery-discharge',
  'ev-charging',
] as const;

export type ScheduleType = typeof scheduleTypes[number];

export const batteryScheduleTypes = [
  'battery-charge',
  'battery-discharge',
] as const;

export const evScheduleTypes = ['ev-charging'] as const;

export const chargingCurrentMin = 6;
export const chargingCurrentMax = 32;
